const rankingItems = [
  { rank: 1, title: '知名带货主播涉嫌虚假宣传被立案调查', heat: '9.8万', trend: '🔥' },
  { rank: 2, title: '选秀节目导师内定黑幕完整录音曝光', heat: '8.6万', trend: '📈' },
  { rank: 3, title: '某女星与经纪人恋情实锤，酒店同框照', heat: '7.9万', trend: '🔥' },
  { rank: 4, title: '富二代网红跑车被查封现场视频流出', heat: '7.2万', trend: '📈' },
  { rank: 5, title: '男团成员队内霸凌事件持续发酵升级', heat: '6.5万', trend: '🔥' },
  { rank: 6, title: '顶流网红偷逃税款细节全曝光引众怒', heat: '5.8万', trend: '📈' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热议榜单
            </h2>
            <span className="text-xs text-foreground-400 ml-auto">实时热度</span>
          </div>

          <div className="space-y-2">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-3 md:p-4 bg-background-50 rounded-lg border border-background-200/50 hover:border-primary-200 transition-colors cursor-pointer group"
              >
                <span
                  className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold ${
                    item.rank === 1
                      ? 'bg-primary-500 text-background-50'
                      : item.rank === 2
                      ? 'bg-accent-500 text-background-950'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="flex-1 text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </span>
                <span className="flex-shrink-0 text-xs text-accent-600 font-semibold whitespace-nowrap">
                  {item.trend} {item.heat}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}